import { useMutation } from '@tanstack/react-query';
import { updateBusiness } from '@Services/api/businessAddress.api';
import type { MutationOnSuccess } from '@Types/util';

type UpdateBusinessAddressOnSuccess = MutationOnSuccess<typeof updateBusiness>;

export const useUpdateBusinessAddress = (onSuccess: UpdateBusinessAddressOnSuccess) =>
  useMutation({
    mutationFn: updateBusiness,
    mutationKey: ['updateKnowYourBusiness'],
    onSuccess,
  });
